import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import RoomProvider from './context/RoomContext';

import global_en from './assets/translations/en/global.json';
import global_srb from './assets/translations/serbian/global.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

const selectedLanguage = localStorage.getItem('selectedLanguage');

i18next.init({
  interpolation: {escapeValue: false},
  lng: selectedLanguage || "English",
  // lng: "English",
  resources:{
    English:{
      global: global_en,
    },
    Srpski:{
      global:global_srb,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <RoomProvider>
    <React.StrictMode>
    <I18nextProvider i18n = {i18next}>
      <App />
    </I18nextProvider>
    </React.StrictMode>
  </RoomProvider>
  
);
